import { CanMatchFn } from '@angular/router';
import { inject } from '@angular/core';
import { SettingsService } from './settings-page/settings-service/settings.service';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const tokenBillingGuard: CanMatchFn = (route, segments) => {
  const settingsService = inject(SettingsService);

  return settingsService.isTokenBillingEnabled$();
};
